/**
 * @generated SignedSource<<30b9cd55d0b51927afcf4554e8ce89f3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentDeleteFragment$data = {
  readonly author: {
    readonly id: string;
  };
  readonly id: string;
  readonly parent: {
    readonly id: string;
  } | null | undefined;
  readonly topic: {
    readonly id: string;
  };
  readonly " $fragmentType": "CommentDeleteFragment";
};
export type CommentDeleteFragment$key = {
  readonly " $data"?: CommentDeleteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentDeleteFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentDeleteFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topic",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "Comment",
  "abstractKey": null
};
})();

(node as any).hash = "b18e3f59399db8f38a4aa489f537b1ca";

export default node;
